import { date_id, makeProgramText, time_to_min } from "../helpers/helpers";
import { JoiEvent, LabelObject, Ranking, Venue } from "../store/events.data";
import { Performer } from "../store/performers.data";
import { Program, Session } from "../store/programs.data";
import { BrandingData } from "../store/publish.data";
import { Sponsor } from "../store/sponsors.data";


export interface FacilitatorTimelineSession {
  start: string
  duration: number
  end: string
  sessionId: string
  break?: boolean
  pID: string
  title: string
  description: string
  facilitatorNotes: string
  programText: string
  performerIds: string[]
  sponsorIds: string[]
  performerRoleIds: { [pId: string]: string }
}

export interface FacilitatorTimelineDay {
  programId: string
  dateString: string // dateId
  date: number
  sessions: FacilitatorTimelineSession[]
}

export interface FacilitatorShareData {
  eventTitle: string
  programTitle: string
  facilitatorNotes: string
  labelIds: string[]
  labelMap: LabelObject
  venue: Venue
  location: string
  locationConfirmed: boolean
  timeline: FacilitatorTimelineDay[]
  performers: { [pId:string]: Performer }
  sponsors: { [sId:string]: Sponsor }
  brandingData: BrandingData
  performerRoles: { [pId: string]: Ranking }
}

export const getFacilitatorProgramTimeline = (p: Program, event: JoiEvent): FacilitatorTimelineDay[] => p.sessions.map((programDay, k) => {
  
  let dateId, time
  if (p.date) {
    const date = new Date(new Date(p.date).getTime() + k * 24 * 60 * 60 * 1000)
    dateId = date_id(date)
    time = date.getTime()
  } else {
    dateId = `Day ${k + 1}`
    time = k + 1
  }
  return {
    programId: p.id, 
    dateString: dateId, 
    date: time, 
    sessions: programDay.sessions.map((sessionId) => {
      const session:Session = p.sessions_obj[sessionId];
      return {
        start: session.start,
        duration: session.duration,
        end: session.end,
        sessionId,
        pID: p.id,
        sponsorIds: session.sponsorIds,
        title: session.title,
        description: session.description,
        facilitatorNotes: session.facilitatorNotes || '',
        break: session.type === 'break',
        publicLinks: session.publicLinks,
        programText: makeProgramText(p.title, p.location || '', event.venues[p.venueId]),
        performerIds: session.performerIds,
        performerRoleIds: session.performerRoles
      }
    }).sort((s1: any, s2: any) => (time_to_min(s1.start) - time_to_min(s2.start)) || time_to_min(s1.end) - time_to_min(s2.end))
  }
}).sort((p1, p2) => p1.date > p2.date ? 1 : -1)



